import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { formaterOctets } from '../../lib/format.js';
import type { VueDAigle } from '../../types.js';
import commun from './commun.module.css';
import { Section } from './composants.js';
import { useFormats } from './formats.js';
import styles from './Usage.module.css';

/**
 * L'usage agrégé : utilisateurs actifs, œuvres, stockage. Les œuvres et le
 * stockage viennent d'une mesure (`usage:measure`) : tant qu'elle n'a jamais
 * eu lieu, « mesure non disponible » — jamais un zéro qui laisserait croire
 * que la plateforme est vide.
 */
export function Usage({ vue, numero }: { vue: VueDAigle; numero: string }): JSX.Element {
  const { t } = useTranslation('console');
  const f = useFormats();
  const { usage } = vue;
  const mesure = usage.mesureLe !== null;
  const stockageMesure = mesure || usage.stockageOctets > 0;

  const nonMesure = (
    <>
      <dd className={`${commun.valeur} ${commun.valeurTexte}`}>{t('vueDAigle.usage.nonMesure')}</dd>
      <dd className={commun.aide}>{t('vueDAigle.usage.nonMesureAide')}</dd>
    </>
  );

  return (
    <Section
      id="usage"
      numero={numero}
      titre={t('vueDAigle.usage.titre')}
      note={
        usage.mesureLe
          ? t('vueDAigle.usage.mesureLe', { date: f.dateHeure(usage.mesureLe) })
          : t('vueDAigle.usage.note')
      }
    >
      <dl className={styles.usage}>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.usage.utilisateurs')}</dt>
          <dd className={commun.valeur}>{f.nombre(usage.utilisateursActifs30j)}</dd>
        </div>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.usage.oeuvres')}</dt>
          {mesure ? <dd className={commun.valeur}>{f.nombre(usage.oeuvres)}</dd> : nonMesure}
        </div>
        <div className={commun.tuile}>
          <dt>{t('vueDAigle.usage.stockage')}</dt>
          {stockageMesure ? (
            <dd className={commun.valeur}>{formaterOctets(usage.stockageOctets)}</dd>
          ) : (
            nonMesure
          )}
        </div>
      </dl>
    </Section>
  );
}
